<template>
  <layout>
    <template v-slot:header>
      <AppHead title="Boxes" />
      <h2>Boxes</h2>
      <flash-messages />
    </template>
        
    <template v-slot:default>
      <div class="table-responsive">
        <table class="table table-striped tbody-border">
          <thead>
          <tr>
            <th>Code</th>
            <th>Width</th>
            <th>Length</th>
            <th>Depth</th>
            <th>Max Weight</th>
            <th>system</th>
            <th>one rate</th>
          </tr>
          </thead>
          <tbody>
            <tr v-for="box in boxes" :key="box.id">
              <td>{{ box.code }}</td>
              <td>{{ box.width }}</td>
              <td>{{ box.length }}</td>
              <td>{{ box.depth }}</td>
              <td>{{ box.max_weight }}</td>
              <td>{{ box.active }}</td>
              <td>{{ box.one_rate }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="col-12 col-md-6 col-lg-4 px-0 mt-3">
        <card title="New Box" icon="fas fa-plus" headerStyle="dark">
          <div class="d-flex">
            <div class="mr-2">
              <label class="mb-0">Code:</label>
              <input type="text" class="form-control custom-form-inline" v-model="formBox.code">
            </div>
            <div class="mr-2">
              <label class="mb-0">W:</label>
              <input type="text" class="form-control custom-form-inline" v-model="formBox.width">
            </div>
            <div class="mr-2">
              <label class="mb-0">L:</label>
              <input type="text" class="form-control custom-form-inline" v-model="formBox.length">
            </div>
            <div>
              <label class="mb-0">D:</label>
              <input type="text" class="form-control custom-form-inline" v-model="formBox.depth">
            </div>
          </div>
          <jet-button type="button" btnStyle="success" icon="fas fa-plus" class="mt-3" @click="createBox(box)">Create Box</jet-button>
        </card>
      </div>
    </template>
  </layout>
</template>

<script>
import Layout from '@/Shared/Admin/Layout'

import JetInput from '@/Jetstream/Input'
import JetInputError from '@/Jetstream/InputError'
import JetLabel from '@/Jetstream/Label'

import moment from 'moment'
import FlashMessages from '@/Shared/FlashMessages'
import SelectButton from 'primevue/selectbutton';

export default {
  components: {
    Layout,
    SelectButton,
    FlashMessages,
    JetInput,
    JetInputError,
    JetLabel,
  },
  props: {
    boxes: Array
  },
  data() {
    return {
        formBox: this.$inertia.form({
          _method: 'put',
          code: null,
          width: 0,
          length: 0,
          depth: 0
        }),
    }
  },
  created: function () {
    this.moment = moment;
  },
  methods: {
    createBox(box) {
      let component = this;
      axios.post(this.route('admin.box.store'), {
                    code: this.formBox.code,
                    width: this.formBox.width,
                    length: this.formBox.length,
                    depth: this.formBox.depth
              }).then((response) => {
                window.location.reload();
              });
    },
  },
}

</script>
